(() => {
  function update(popups) {
    for (const popup of popups) {
    if (!popup.querySelector('form')) continue;
    popup.classList.add('p26-welcome-popup');
    const title = popup.querySelector('.css-snfyn0');
    if (title && title.textContent.trim() === 'A Special Reward Is Waiting For You') title.textContent = 'A little welcome, just for you.';
    const intro = popup.querySelector('p');
    if (intro && intro.textContent.trim() === 'Sign up using your email to receive the code!' && popup.querySelector('input[type="tel"]')) intro.textContent = 'Enter your mobile number to receive your welcome code.';
    const phone = popup.querySelector('input[type="tel"]');
    if (phone && !phone.hasAttribute('aria-label')) { phone.setAttribute('aria-label', 'Mobile number'); phone.setAttribute('autocomplete', 'tel-national'); }
    const close = popup.querySelector('.css-e0hixd');
    if (close && !close.hasAttribute('role')) {
      close.setAttribute('role', 'button'); close.setAttribute('tabindex', '0'); close.setAttribute('aria-label', 'Close welcome offer');
      close.addEventListener('keydown', event => { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); close.click(); } });
    }
    }
  }
  const popupSelector = '[id^="dc-container-"]';
  const pending = new Set();
  let queued = false;
  function collect(node) {
    if (node.nodeType !== 1) return;
    const popup = node.closest(popupSelector);
    if (popup) pending.add(popup);
    node.querySelectorAll(popupSelector).forEach(element => pending.add(element));
  }
  new MutationObserver(records => {
    for (const record of records) {
      const popup = record.target.nodeType === 1 && record.target.closest(popupSelector);
      if (popup) pending.add(popup);
      record.addedNodes.forEach(collect);
    }
    if (!pending.size || queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      const popups = Array.from(pending).filter(popup => popup.isConnected);
      pending.clear();
      update(popups);
    });
  }).observe(document.body, {childList:true, subtree:true});
  update(document.querySelectorAll(popupSelector));
})();

document.addEventListener('change', event => { const select=event.target.closest('[data-p26-view]'); if (!select) return; const list=document.getElementById(select.dataset.p26View); if(list) list.classList.toggle('p26-editorial',select.value==='editorial'); });

// Send normal shopping links straight to available results without an extra page load.
document.addEventListener('click', event => {
  const link = event.target.closest('a[href]');
  if (!link || link.hasAttribute('download')) return;
  const url = new URL(link.href, location.href);
  if (url.origin !== location.origin) return;
  const shoppingPage = url.pathname.includes('/collections/') || (url.pathname.endsWith('/search') && url.searchParams.has('q'));
  if (!shoppingPage || url.searchParams.has('filter.v.availability') || url.searchParams.get('p26_stock') === 'all') return;
  url.searchParams.set('filter.v.availability', '1');
  link.href = url.href;
}, true);

// Native filter dropdowns close without moving the shopper into a side panel.
document.addEventListener('click', function(event) {
  document.querySelectorAll('.p26-filter-dropdown[open]').forEach(function(dropdown) {
    if (!dropdown.contains(event.target)) dropdown.open = false;
  });
});
document.addEventListener('keydown', function(event) {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.p26-filter-dropdown[open]').forEach(function(dropdown) {
    dropdown.open = false;
    dropdown.querySelector('summary').focus();
  });
});
